<template>
  <div>
    <div class="checkbox">
      <div class="checkhotelbox">
        <el-form ref="form" label-width="100px">
          <el-form-item label="入住日期">
            <el-date-picker
              v-model="checkInDate"
              type="date"
              placeholder="选择入住日期"
              :picker-options="checkInOptions"
              @change="handleCheckInDateChange"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="离店日期">
            <el-date-picker
              v-model="checkOutDate"
              type="date"
              placeholder="选择离店日期"
              :picker-options="checkOutOptions"
            >
            </el-date-picker>
          </el-form-item>
          <div class="checkform">
            <el-button type="primary" @click="submitCheckhotel">提交</el-button>
          </div>
        </el-form>
      </div>
      <div class="tipsimg">
        <img src="@/assets/images/sidebanner.png" />
        <h3 v-if="telphone">{{ telphone }}</h3>
      </div>
    </div>
  </div>
</template>
  
  <script>
import moment from "moment";
import { setStorage, getStorage } from "@/common/until/until";
export default {
  name: "Leftcheck",
  data() {
    return {
      checkInDate: new Date(),
      checkOutDate: new Date(new Date().getTime() + 86400000),
      checkInOptions: {
        disabledDate(date) {
          // 禁用入住日期之前的所有日期
          return date && date.valueOf() < Date.now() - 86400000;
        },
      },
      checkOutOptions: {disabledDate: (date) => {
          // 禁用离店日期早于或等于入住日期的所有日期
         
          return  date && date.valueOf() <= this.checkInDate.valueOf();
        }},
    };
  },
  computed: {
    checkOutOptionss() {
      var that = this;
      return {
        
      };
    },
  },created() {
  const hid = this.$route.query.hid;
  const tm1 = this.$store.state.checkInDateDefult || this.$route.query.tm1;
  const tm2 = this.$store.state.checkOutDateDefult || this.$route.query.tm2;
 
  if (tm1 && tm2) {
    this.checkInDate = new Date(tm1);
    this.checkOutDate = new Date(tm2);
  }
},
  methods: {
   
    getHotelRoom() {
        
  this.$emit('date-changed', { hid: this.hid, tm1: this.checkInDate, tm2: this.checkOutDate });
},
    handleCheckInDateChange(value) {
      // 仅当离店日期为空或早于入住日期时，才更新为入住日期的下一天
      // const formattedDate = moment(this.checkOutDate).format('YYYY-MM-DD');

      if (!this.checkOutDate || moment(this.checkOutDate).startOf('day') <= moment(value).startOf('day')) {
        this.checkOutDate = new Date(value.getTime() + 86400000);
      }
    },
    handleCheckOutDateChange(value) {
      if (value < this.checkInDate) {
        this.checkOutDate = new Date(this.checkInDate.getTime() + 86400000);
      }
    },
    submitCheckhotel() {
      const hid = getStorage("cachedId");
      const tm1 = moment(this.checkInDate).format("YYYY-MM-DD");
      const tm2 = moment(this.checkOutDate).format("YYYY-MM-DD");
      this.$store.commit("setCheckInDateDefult", tm1);
      this.$store.commit("setCheckOutDateDefult", tm2);
      const queryParams = `hid=${hid}&tm1=${tm1}&tm2=${tm2}`;
      this.$router.push(`/booking?${queryParams}`);

      this.$emit('submit');
    },
  },
  computed: {
    hotelinfro() {
      return this.$store.state.hotelinfro; // 访问 Vuex Store 中的状态
    },telphone() { 
      return this.$store.state.hotelphone; // 访问 Vuex Store 中的状态
    }
  },
};
</script>
  <style lang="less" scope>
.menu {
  font-size: 16px;
  font-weight: 400;
  color: #180808;
}
.checkhotelbox {
  margin-bottom: 65px;
  .el-form-item {
    border: 1px solid #dbdbdb;
    .el-input__inner {
      border: none;
    }
    .el-form-item__label {
      width: 70px !important;
      padding: 0 0 0 10px;
    }
    .el-form-item__content {
      margin-left: 70px !important;
    }
  }
  .checkform .el-button {
    width: 100%;
    height: 44px;
    background: linear-gradient(
      90deg,
      rgba(50, 220, 163, 0.74),
      rgba(38, 182, 199, 0.74)
    );
    border-radius: 22px;
    border: none;
    span {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
    }
  }
}
.tipsimg {
  position: relative;
  h3 {
    position: absolute;
    width: 100%;
    top: 64px;
    text-align: center;
    line-height: 34px;
    font-size: 24px;
    font-family: Arial;
    font-weight: 400;
    color: #ff5555;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {

  
}
</style>
  